import classnames from 'classnames';
import styles from './PricingPlan.module.scss';

export default function PricingPlan({ plan, onClick, selected = false }) {

  return (
    <div 
      className={classnames(styles.container, {
        [styles.selected]: selected
      })} 
      onClick={onClick}
      key={plan.id}
    >
      <div className={styles.header}>
        <div>{plan.title}</div>
        <div>{plan.prettyPrice}</div>
      </div>
      <div className={styles.body}>
        <div className={styles.desc}>{plan.description}</div>
      </div>
    </div>    
  );
}
